import { forwardRef } from 'react';
import { Input } from '@twnel/web-components';

const InputWithRef = forwardRef((props, ref) => (
  <Input ref={ref} {...props} />
));

InputWithRef.displayName = 'InputWithRef';

export default InputWithRef;
